import React from "react";
import classNames from "classnames";
import './Banners.scss';

export default function Banners(props) {

  const { type } = props;

  const classes = classNames("banners", {
    "warning": type === "warning",
    "info": type === "info",
    "success": type === "success",
    "error": type === "error",
  });

  return (
    <div className={classes}>
      {props.children}
    </div>
  );
}